import * as React from "react";
import {} from "@blueprintjs/core";
import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import { useCommonHooks } from "../../hooks";

import { nameof } from "../../utils";
import { ReferentialItemDto } from "../../api";
import { usePositionRef } from "../../hooks/applicationHooks/usePostionRef";

export interface PositionSelectProps
  extends Pick<
    IFGSelectInputProps<any>,
    | "requiredMark"
    | "visible"
    | "disabled"
    | "style"
    | "readonly"
    | "inline"
    | "noLabel"
  > {
  name: string;
  label?: string;
  loading?: boolean;
}

export const PositionSelect: React.FunctionComponent<PositionSelectProps> = ({
  name,
  label,
  loading = false,
  ...fgSelectInputProps
}) => {
  const { t } = useCommonHooks();
  const { positions, loading: posLoading } = usePositionRef();

  return (
    <FGSelectInput
      label={label || t("Position")}
      name={name}
      items={positions}
      loading={posLoading || loading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};

export default PositionSelect;
